import { initializeSdk } from '@eventbrite/statsig';
import { AppProps } from './types';

export const getUserTrackingIDs = ({ gaSettings }: AppProps) => ({
    correlationId: gaSettings?.correlationId,
});

export const initializeStatsigSdk = async (app: AppProps) => {
    await initializeSdk({
        user: {
            customIDs: getUserTrackingIDs(app),
            userID: app.user?.id,
            custom: {
                eventId: app.event?.id,
                organizerId: app.organizer?.id,
            },
        },
    });
};
